export default function Logo({ size = 26 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      data-testid="logo-mark"
    >
      <rect width="32" height="32" rx="8" fill="#0A0A0A" stroke="rgba(255,255,255,0.14)" />
      <path d="M16 5l2.6 8.4L27 16l-8.4 2.6L16 27l-2.6-8.4L5 16l8.4-2.6z" fill="#00E5FF" />
      <circle cx="24.5" cy="7.5" r="2" fill="#39FF14" />
    </svg>
  );
}
